import get from 'lodash.get';

const DEFAULT_NAME = 'NAME MISSING';

export const transform = (data) => {
  let names = [];
  let scores = [];
  let locales = [];
  let labeledScores = [];

  data.map(item => {
    const name = `${get(item, 'first_name', DEFAULT_NAME)} ${get(item, 'last_name', DEFAULT_NAME)}`;
    names.push(name);
    item.scores.map(({score, locale, labeledScore}) => {
      scores.push(score);
      locales.push(locale);
      labeledScores.push(labeledScore);
    });
  });

  return { scores, names, locales, labeledScores };
}

export default { transform };